import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-wallet-05',
  imports: [],
  templateUrl: './wallet-05.html',
  styleUrl: './wallet-05.scss',
})
export class Wallet05 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
